module.exports = __webpack_public_path__ + "static/media/trusted-good-food.be7902c2.png";